import Contextmenu from "./src/index"

export default Contextmenu